import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {WidgetResumenUsuariosComponent} from "./widget-resumen-usuarios.component";
import {TarjetaResumenCantidadModule} from "../tarjeta-resumen-cantidad/tarjeta-resumen-cantidad.module";

@NgModule({
  declarations: [
    WidgetResumenUsuariosComponent
  ],
  exports: [
    WidgetResumenUsuariosComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    TarjetaResumenCantidadModule,
  ]
})
export class WidgetResumenUsuariosModule {
}
